import { authHeader, handleResponse } from "../../_helpers";
import { authenticationService } from "../authentication.service";
import { encData } from "../../_helpers/_helperFunctions";

function updateCourseStatus(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: encData(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/course-user-status/update`,
    requestOptions,
  ).then(handleResponse);
}

export const courseUserStatusService = {
  updateCourseStatus,
};
